<template>
  <div class="layout">
    <Header :mensaje="datoRecibido" />
    <main class="content">
      <router-view @datoEnviado="recibirDato" />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/home/Header.vue';
import Footer from '@/components/home/Footer.vue';

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      datoRecibido: '' // Aquí guardaremos el dato recibido de Services.vue
    };
  },
  methods: {
    recibirDato(dato) {
      this.datoRecibido = dato;
    }
  }
};
</script>

<style>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: 90px;
  background: #ffffff;
}

.content {
  flex: 1; /* El contenido ocupa el espacio restante */
  padding: 20px;
}
</style>
